import { ComponentType, FC } from 'react'
import { useLocation } from 'react-router-dom'
import Gateway from 'views/gateway'

export default function withGateway(Component: ComponentType): FC {
  return () => {
    const { pathname } = useLocation()

    if (pathname === '/gateway') return <Gateway />

    return <Component />
  }
}
